import React from 'react'
import PropTypes from 'prop-types'

const CardButton = ({ text }) => (
  <div className='card-price col-12 mt-1 mb-1 p-0'>
    <div className='row align-items-center h-100'>
      <div className='card-price col-12 mt-2 mb-1 px-1'>
        <div className='row align-items-center h-100'>
          <div className='card-price-item col-12 px-0 z-p-0'>
            <div className='row'>
              <div className='card-price-points col-12 txt-title txt-font-body'>
                {text}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

CardButton.propTypes = {
  text: PropTypes.string.isRequired
}

export default CardButton



// WEBPACK FOOTER //
// ./src/Catalog/Service/ServiceCard/CardButton/index.js